export default  {"src":"/_next/static/image/public/images/icons/log-in-outline.358db240c6da9be7a06a6f8570d9217a.svg","height":20,"width":21};